import React from 'react';
import styled from 'styled-components';

import Modal from './Modal';

import instaIcon from '../assets/images/insta-icon.png';
import twitterIcon from '../assets/images/twitter.png';
import fbIcon from '../assets/images/fb-icon.png';

const icons = [
	{
		src: instaIcon,
		alt: 'instagram icon',
		url: 'https://www.instagram.com/blidzcom/'
	},
	{
		src: twitterIcon,
		alt: 'twitter icon',
		url: 'https://twitter.com/blidzcom'
	},
	{
		src: fbIcon,
		alt: 'facebook icon',
		url: 'https://www.facebook.com/blidzcom'
	}
];

const FooterWrapper = styled.footer`
	font-size: var(--fs-small);
	padding: 20px 10vw 20px;
	padding: 20px var(--side-margin) 20px;
	text-align: center;
	color: silver;

	> * {
		margin-bottom: 20px;
	}
`;

const Ul = styled.ul`
	display: flex;
	list-style: none;
	justify-content: center;
	white-space: nowrap;

	> * {
		&:not(:last-child) {
			margin-right: 5%;
		}

		.label {
			color: black;
			text-transform: uppercase;
			text-decoration: underline;
			cursor: pointer;
		}
	}
`;

const BottomText = styled.article`
	font-size: var(--fs-x-small);
`;

const Icon = styled.img`
	width: 40px;
	height: 40px;
`;

const Footer = ({ terms, privacy }) => {
	const iconListItems = icons.map(({ src, alt, url }, i) => (
		<li key={i}>
			<a href={url} target="_blank" rel="noopener noreferrer">
				<Icon src={src} alt={alt} />
			</a>
		</li>
	));

	return (
		<FooterWrapper>
			<Ul>
				<li>
					<a className="label" href="mailto:pr@blidz.com">
						PR Inquires
					</a>
				</li>
				<li>
					<Modal text={terms}>
						<span className="label">TERMS OF SERVICE</span>
					</Modal>
				</li>
				<li>
					<Modal text={privacy}>
						<span className="label">PRIVACY POLICY</span>
					</Modal>
				</li>
			</Ul>
			<Ul>{iconListItems}</Ul>
			<div>
				<em>Copyright &copy; Blidz Inc.. All rights reserved.</em>
			</div>
			<BottomText>
				<div>
					Apple, the Apple logo, and iPhone are trademarks of Apple Inc.,
					registered in the U.S. and other countries
				</div>
				<div>
					Apple Watch is a trademark of Apple Inc. App Store is a service mark
					of Apple Inc.
				</div>
				<div>Google Play is a trademark of Google Inc.</div>
			</BottomText>
		</FooterWrapper>
	);
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js